import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-progressBar",
  "use": "icon-progressBar-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-progressBar\">\n<g id=\"icon-progressBar_Group 10252\">\n<circle id=\"icon-progressBar_Ellipse 573\" opacity=\"0.7\" cx=\"8\" cy=\"8\" r=\"8\" fill=\"#B09FD9\" />\n<circle id=\"icon-progressBar_Ellipse 574\" cx=\"8.00033\" cy=\"7.9974\" r=\"5.33333\" fill=\"white\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol